/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Stav hromadné editace featur. RUNNING – dávka běží; SUCCESS – transakce byla potvrzena (data jsou uložena); ERROR – dávka skončila chybou a nic se neuložilo; UNKNOWN – server o dávce nic neví (vypršelý záznam, jiný uzel), o výsledku nelze říct nic.
 * @export
 * @enum {string}
 */

export const EnumFeatureBatchOutcome = {
    RUNNING: 'RUNNING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    UNKNOWN: 'UNKNOWN'
} as const;

export type EnumFeatureBatchOutcome = typeof EnumFeatureBatchOutcome[keyof typeof EnumFeatureBatchOutcome];



